import { format, parseISO } from '@sequencehq/utils/dates'

export const formatTimestamp = (timestamp: string): string => {
  return format(parseISO(timestamp), 'd MMM yyyy • HH:mm')
}
